"use client";

import { useEffect } from "react";

export function CopyProtection() {
  useEffect(() => {
    // Console warning for anyone inspecting
    console.log("%c\u26a0\ufe0f Stop!", "color: red; font-size: 40px; font-weight: bold;");
    console.log(
      "%cDit is een beveiligde omgeving. Ongeautoriseerde toegang tot broncode of reverse engineering is verboden onder onze gebruiksvoorwaarden en het auteursrecht van Elusive Marketing B.V. (KvK 91122708).",
      "font-size: 14px; color: #888;",
    );

    // Disable right-click context menu (except on form inputs)
    const handleContextMenu = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)) {
        e.preventDefault();
      }
    };

    // Block common keyboard shortcuts for viewing/saving source
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+U (view source), Ctrl+S (save), Ctrl+Shift+I (DevTools), F12
      if (
        (e.ctrlKey && e.key === "u") ||
        (e.ctrlKey && e.key === "s") ||
        (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "i")) ||
        (e.ctrlKey && e.shiftKey && (e.key === "J" || e.key === "j")) ||
        (e.ctrlKey && e.shiftKey && (e.key === "C" || e.key === "c")) ||
        e.key === "F12"
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return null;
}
